import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { Reason } from '../models/reason';

@Injectable()
export class ReasonService {
  private baseUrl = environment.apiUrl + environment.apiVersionMain + '/orders/reasons';

  constructor(private http: HttpClient) {
  }

  /** GET reasons from the server, optionally filtered by operator */
  getReasons(operatorId?: number): Observable<Reason[]> {
    let params = new HttpParams();
    if (operatorId != null) {
      params = params.set('operatorId', operatorId.toString());
    }
    return this.http.get<Reason[]>(this.baseUrl, { params });
  }
}
